export default __webpack_public_path__ + "static/media/StarPage1.ab789cce.txt";